module.exports = __webpack_public_path__ + "img/btn-lesson-flow@2x.7d0c7a28.jpg";